import { Search, X } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../../i18n/config';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';

interface CaseSearchBoxProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

/**
 * Component for searching cases
 */
const CaseSearchBox: React.FC<CaseSearchBoxProps> = ({ searchTerm, setSearchTerm }) => {
  const { t, i18n } = useTranslation();
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';

  return (
    <div className="mb-4 relative" dir={getLanguageDirection(i18n.language)}>
      <Search className={`absolute ${isRTL ? 'right-3' : 'left-3'} top-3 w-4 h-4 text-muted-foreground`} />
      <Input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder={t('components.cases.searchPlaceholder')}
        className={`${isRTL ? 'pr-9 pl-9' : 'pl-9 pr-9'}`}
      />
      {searchTerm && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setSearchTerm('')}
          className={`absolute ${isRTL ? 'left-1' : 'right-1'} top-1 h-8 w-8`}
        >
          <X className="w-3.5 h-3.5" />
        </Button>
      )}
    </div>
  );
};

export default CaseSearchBox;
